import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  changeCancellationsFilterGroupBy,
  findCancellationsRequested,
  reportCancellationsFilterStartAccountingDateSelector,
  reportCancellationsFilterEndAccountingDateSelector,
  reportFilterCountryCodeSelector,
  reportCancellationsFilterGroupBySelector,
  reportCancellationsLoadingSelector,
} from '../../state';

import {
  CountryFilter,
  ReportActionsGridItem,
  ReportFilterActions,
  ReportFilters,
  ReportFiltersProps,
  StoreFilter,
} from '../ReportFilters';

import { AppPermissions, ReportCancellationsGroupBy } from '../../types';
import { PermissionsProvider } from '../Permissions';
import { FilterPanel, StatusChip } from '../Visual';
import { AccountingDateRangeFilter } from './filters';

const groupByConfig: ReportFiltersProps<ReportCancellationsGroupBy>['groupByConfig'] = {
  options: {
    countryAcronym: true,
    storeAcronym: false,
    accountingDate: false,
  },
  action: changeCancellationsFilterGroupBy,
  selector: reportCancellationsFilterGroupBySelector,
};

const onedriveAction = () => findCancellationsRequested(true);

const CancellationsSearch = () => {
  const { t } = useTranslation();
  const startDate = useSelector(reportCancellationsFilterStartAccountingDateSelector);
  const endDate = useSelector(reportCancellationsFilterEndAccountingDateSelector);
  const hasCountry = Boolean(useSelector(reportFilterCountryCodeSelector));
  const applyDisabled = !(startDate.accept && endDate.accept && hasCountry);
  const countryRequiredIncomplete = applyDisabled && !hasCountry;
  const accountingDateRequiredIncomplete = applyDisabled && !(startDate.accept && endDate.accept);

  return (
    <PermissionsProvider resourcePermissions={[AppPermissions.CANCELLATIONS]}>
      <ReportFilters
        groupByConfig={groupByConfig}
        loadingSelector={reportCancellationsLoadingSelector}
        applyAction={findCancellationsRequested}
        onedriveAction={onedriveAction}
      >
        <FilterPanel
          subtitleTranslationKey="cancellations.filters.subtitle"
          actions={
            <StatusChip
              status={applyDisabled ? 'warning' : 'success'}
              label={
                applyDisabled ? t('filters.status.missingRequired') : t('filters.status.ready')
              }
            />
          }
        >
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} md={3} lg={2} xl={2}>
              <CountryFilter fullWidth requiredIncomplete={countryRequiredIncomplete} />
            </Grid>
            <Grid item xs={12} md={3} lg={2} xl={2}>
              <StoreFilter />
            </Grid>
            <Grid item xs={12} md={6} lg={5} xl={3}>
              <AccountingDateRangeFilter
                spacing={1}
                requiredIncomplete={accountingDateRequiredIncomplete}
              />
            </Grid>
            <ReportActionsGridItem>
              <ReportFilterActions applyDisabled={applyDisabled} />
            </ReportActionsGridItem>
          </Grid>
        </FilterPanel>
      </ReportFilters>
    </PermissionsProvider>
  );
};

export default CancellationsSearch;
